export default {"src":"/_next/static/media/grpChat.840e5eab.svg","height":37,"width":38};